import React from "react";
import { withTranslation } from "react-i18next";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { Row, Col } from "reactstrap";

import useUser from "../../../../core/hooks/use-user";

const Dashboard = () => {
const { getUserData } = useUser();
const userData = getUserData();

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    Panel
                    <small>Hola {userData?.nombres ?? ""}</small>
                </div>
            </div>
            <Row>
                <div className="col-xl-3 col-md-6">
                    {/* START widget */}
                    <div className="card bg-purple pt-2 b0">
                        <div className="px-2">
                            <em className="icon-cloud-upload fa-lg float-right"></em>
                            <div className="text-uppercase">
                                SOLICITUDES RECIBIDAS
                            </div>
                            <div className="h2 mt0">0</div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-md-6">
                    {/* START widget */}
                    <div className="card bg-info pt-2 b0">
                        <div className="px-2">
                            <em className="icon-globe fa-lg float-right"></em>
                            <div className="text-uppercase">
                                SOLICITUDES RECIBIDAS
                            </div>
                            <div className="h2 mt0">0</div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                    {/* START widget */}
                    <div className="card bg-danger pt-2 b0">
                        <div className="px-2">
                            <em className="icon-bubbles fa-lg float-right"></em>
                            <div className="text-uppercase">
                                <div className="text-uppercase">
                                    SOLICITUDES RECIBIDAS
                                </div>
                            </div>
                            <div className="h2 mt0">0</div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                    {/* START widget */}
                    <div className="card bg-success pt-2 b0">
                        <div className="px-2">
                            <em className="icon-pencil fa-lg float-right"></em>
                            <div className="text-uppercase">
                                SOLICITUDES CERRADAS
                            </div>
                            <div className="h2 mt0">0</div>
                        </div>
                    </div>
                </div>
            </Row>
            <Row>
                <Col lg={12}>
                    {/* START panel tab */}
                    <div className="card card-transparent">Graficas</div>
                    {/* END panel tab */}
                </Col>
            </Row>
            {/* START Widgets*/}
            <Row>
                <Col lg={12}>
                    {/* START panel tab */}
                    <div className="card card-transparent">Estadisticas</div>
                    {/* END panel tab */}
                </Col>
            </Row>
            {/* END Widgets*/}
        </ContentWrapper>
    );
};

export default withTranslation("translations")(Dashboard);
